import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Fish } from "lucide-react";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      await api.post("/subscribe", { email });
      toast.success("You're on the list. We'll only email when it matters.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="border-t border-border bg-[#E6E2D6] mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <Fish className="w-5 h-5 text-[#2D5A4C]" strokeWidth={1.5} />
            <span className="font-display text-xl">ecofisherman<span className="text-[#C95B3B]">.</span></span>
          </div>
          <p className="text-sm text-muted-foreground max-w-md leading-relaxed">
            Regulations, eco-friendly gear, and honest reviews for anglers who care about the waters they fish.
          </p>
          <form onSubmit={submit} className="mt-6 flex gap-2 max-w-sm" data-testid="footer-subscribe-form">
            <input
              type="email"
              placeholder="you@yourwater.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="subscribe-email-input"
              className="flex-1 px-4 py-3 bg-white border border-border text-sm focus:outline-none focus:border-foreground"
            />
            <button type="submit" disabled={submitting} className="btn-primary text-sm px-5 py-3" data-testid="subscribe-submit">
              {submitting ? "..." : "Subscribe"}
            </button>
          </form>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/regulations" className="hover:text-[#C95B3B]">Regulations Map</Link></li>
            <li><Link to="/gear" className="hover:text-[#C95B3B]">Eco Gear</Link></li>
            <li><Link to="/journal" className="hover:text-[#C95B3B]">Journal & Reviews</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Site</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[#C95B3B]">About</Link></li>
            <li><Link to="/admin/login" className="hover:text-[#C95B3B]" data-testid="footer-admin-link">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} EcoFisherman. Fish clean. Leave nothing behind.</p>
          <p>As an Amazon Associate, ecofisherman.com earns from qualifying purchases. Product links may be affiliate — we only feature gear we'd use.</p>
        </div>
      </div>
    </footer>
  );
};
